import { useState, useEffect } from 'react';
import mediaFounder from '../../Assets/_GINI AWARD DEBASHISH ROY.jpeg';
import mediaAward from '../../Assets/GINI AWARD CSP.IN.jpeg'

const MediaCentre = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const isMobile = width <= 768;
    const isTablet = width > 768 && width <= 1024;

    useEffect(() => {
        window.scrollTo(0, 0);
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const colors = {
        primary: '#16b287',
        secondary: '#2c5363',
        text: '#374151',
        lightGray: '#f8f9fa',
        white: '#ffffff',
        accent: '#e11d48',
    };

    const headerStyle = {
        textAlign: 'center',
        marginBottom: '30px',
    };

    const titleStyle = {
        fontSize: isMobile ? '32px' : (isTablet ? '40px' : '48px'),
        fontWeight: '800',
        color: colors.secondary,
        marginBottom: '20px',
        letterSpacing: '-1px',
    };

    const highlightText = {
        color: colors.primary,
    };

    const cardContainerStyle = {
        display: 'flex',
        flexDirection: (isMobile || isTablet) ? 'column' : 'row',
        gap: '20px',
        justifyContent: (isMobile || isTablet) ? "center" : "flex-start",
        marginBottom: '40px',
        margin: '0 auto 40px auto',
    };

    const cardStyle = {
        flex: 1,
        backgroundColor: colors.white,
        borderRadius: '24px',
        overflow: 'hidden',
        border: `1px solid ${colors.lightGray}`,
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        cursor: 'default',
        maxWidth: (isMobile || isTablet) ? '100%' : '35%',
        width: '100%',
    };

    const imgContainerStyle = {
        width: '100%',
        height: isMobile ? 'auto' : (isTablet ? '450px' : '513px'),
        overflow: 'hidden',
        backgroundColor: colors.lightGray,
    };

    const imgStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'fill',
    };

    const cardBodyStyle = {
        padding: '15px',
        textAlign: 'justify',
    };

    const awardTitleStyle = {
        fontSize: '20px',
        fontWeight: '700',
        color: colors.secondary,
        marginBottom: '10px',
        lineHeight: '1.2',
    };

    const winnerStyle = {
        fontSize: '17px',
        fontWeight: '600',
        color: colors.primary,
        marginBottom: '15px',
    };

    const aboutHeadingStyle = {
        fontSize: '14px',
        fontWeight: '700',
        color: colors.secondary,
        margin: '10px 0 5px 0',
        textTransform: 'uppercase',
        letterSpacing: '1px',
    };

    const sectionTitleStyle = {
        fontSize: isMobile ? '24px' : '28px',
        fontWeight: '700',
        color: colors.secondary,
        marginBottom: '20px',
        position: 'relative',
        display: 'inline-block',
    };

    const underlineStyle = {
        content: '""',
        position: 'absolute',
        bottom: '-10px',
        left: '0',
        width: '60px',
        height: '4px',
        backgroundColor: colors.primary,
        borderRadius: '2px',
    };

    const listContainerStyle = {
        backgroundColor: '#f1f5f9',
        borderRadius: '24px',
        padding: isMobile ? '20px 15px' : (isTablet ? '25px 30px' : '30px 40px'),
        marginBottom: '40px',
    };

    const listItemStyle = {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '15px',
        marginBottom: '15px',
        fontSize: isMobile ? '14px' : '16px',
        fontWeight: '500',
        lineHeight: '1.6',
    };

    const checkIconStyle = {
        color: colors.primary,
        fontSize: '18px',
    };

    const footerParaStyle = {
        fontSize: isMobile ? '16px' : '18px',
        lineHeight: '1.8',
        color: colors.text,
        marginTop: '30px',
        fontStyle: 'italic',
        borderLeft: `4px solid ${colors.lightGray}`,
        paddingLeft: '20px',
    };

    const linkSectionStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        marginTop: '20px',
    };

    const linkCardStyle = {
        padding: '15px 20px',
        backgroundColor: '#f8fafc',
        borderRadius: '16px',
        textDecoration: 'none',
        color: colors.secondary,
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        transition: 'all 0.3s ease',
        border: '1px solid transparent',
        width: '100%',
    };

    return (
        <div className='container' style={{ padding: isMobile ? '6rem 15px' : (isTablet ? '8rem 30px' : "120px 0px") }}>
            {/* Header */}
            <div style={headerStyle}>
                <h1 style={titleStyle}>
                    Media <span style={highlightText}>Centre</span>
                </h1>
                <p style={{ fontSize: isMobile ? '18px' : '20px', margin: '0 auto', lineHeight: '1.6', fontWeight: 500 }}>
                    CSP.in Wins Dual Global Recognition at GINI Global Innovation Awards 2025
                </p>
                <div style={{ marginTop: '30px', textAlign: 'justify', margin: '30px auto' }}>
                    <p style={{ lineHeight: '1.8', fontSize: '16px' }}>
                        CSP.in (CSP India Network Private Limited) has been internationally recognized at the GINI Global Innovation Awards 2025, marking an important milestone in its journey of building last-mile distribution infrastructure across Bharat.
                    </p>
                    <p style={{ lineHeight: '1.8', fontSize: '16px', color: '#64748b' }}>
                        Selected from over 1,470 global submissions and evaluated by 19 international experts across 26 countries, this recognition reflects the growing relevance of grassroots-led, execution-focused innovation emerging from India.
                    </p>
                </div>
            </div>

            {/* Awards & Recognition Section */}
            <div style={{ marginBottom: '40px' }}>
                <h2 style={sectionTitleStyle}>
                    Awards & Recognition
                    <div style={underlineStyle}></div>
                </h2>
                <div style={{ ...cardContainerStyle, marginTop: '40px' }}>
                    <div style={cardStyle} onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-10px)'} onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                        <div style={imgContainerStyle}>
                            <img src={mediaAward} alt="CSP.in Award" style={imgStyle} />
                        </div>
                    </div>
                    <div style={cardStyle} onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-10px)'} onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                        <div style={imgContainerStyle}>
                            <img src={mediaFounder} alt="Debashish Roy Award" style={imgStyle} />
                        </div>
                    </div>
                </div>
            </div>

            {/* What This Recognition Represents */}
            <div style={{ marginBottom: '40px' }}>
                <h2 style={sectionTitleStyle}>
                    What This Recognition Represents
                    <div style={underlineStyle}></div>
                </h2>
                <div style={{ ...listContainerStyle, marginTop: '40px' }}>
                    <div style={listItemStyle}>
                        <span style={checkIconStyle}>✓</span>
                        <span>The emergence of last-mile innovation as critical infrastructure</span>
                    </div>
                    <div style={listItemStyle}>
                        <span style={checkIconStyle}>✓</span>
                        <span>The effectiveness of partner-led, grassroots execution models</span>
                    </div>
                    <div style={listItemStyle}>
                        <span style={checkIconStyle}>✓</span>
                        <span>The importance of trust-driven networks in enabling local economies</span>
                    </div>
                    <div style={listItemStyle}>
                        <span style={checkIconStyle}>✓</span>
                        <span>India's growing role in globally relevant, inclusive innovation</span>
                    </div>

                    <p style={footerParaStyle}>
                        CSP.in continues to focus on building long-term, reliable infrastructure that supports livelihoods while scaling sustainably.
                    </p>
                </div>
            </div>

            {/* Media Coverage */}
            <div style={{ marginBottom: '40px' }}>
                <h2 style={sectionTitleStyle}>
                    Media Coverage
                    <div style={underlineStyle}></div>
                </h2>
                <div style={linkSectionStyle}>
                    <a href="https://www.issuewire.com/indian-startup-cspin-earns-global-recognition-spotlighting-indias-grassroots-innovation-1861800754810278" target="_blank" rel="noopener noreferrer" style={linkCardStyle} onMouseOver={(e) => e.currentTarget.style.borderColor = colors.primary} onMouseOut={(e) => e.currentTarget.style.borderColor = 'transparent'} className='d-flex flex-column gap-3'>
                        <div className='d-flex align-items-center justify-content-between w-100'>
                            <span style={{ fontSize: 16, fontWeight: '700' }}>IssueWire</span>
                            <span style={{ color: colors.primary, fontSize: 14, fontWeight: '700' }}>View Article →</span>
                        </div>
                    </a>
                    <a href="https://www.openpr.com/news/4453469/indian-startup-csp-in-wins-dual-honors-at-gini-global-innovation" target="_blank" rel="noopener noreferrer" style={linkCardStyle} onMouseOver={(e) => e.currentTarget.style.borderColor = colors.primary} onMouseOut={(e) => e.currentTarget.style.borderColor = 'transparent'} className='d-flex flex-column gap-3'>
                        <div className='d-flex align-items-center justify-content-between w-100'>
                            <span style={{ fontSize: 16, fontWeight: '700' }}>OpenPR</span>
                            <span style={{ color: colors.primary, fontSize: 14, fontWeight: '700' }}>View Article →</span>
                        </div>
                    </a>
                    <a href="https://startupstorymedia.com/csp-in-secures-dual-global-recognition-at-gini-awards-2025/" target="_blank" rel="noopener noreferrer" style={linkCardStyle} onMouseOver={(e) => e.currentTarget.style.borderColor = colors.primary} onMouseOut={(e) => e.currentTarget.style.borderColor = 'transparent'} className='d-flex flex-column gap-3'>
                        <div className='d-flex align-items-center justify-content-between w-100'>
                            <span style={{ fontSize: 16, fontWeight: '700' }}>Startup Story</span>
                            <span style={{ color: colors.primary, fontSize: 14, fontWeight: '700' }}>View Article →</span>
                        </div>
                    </a>
                    <a data-bs-toggle="modal" href="#exampleModalToggle" style={linkCardStyle} onMouseOver={(e) => e.currentTarget.style.borderColor = colors.primary} onMouseOut={(e) => e.currentTarget.style.borderColor = 'transparent'} className='d-flex flex-column gap-3'>
                        <div className='d-flex align-items-center justify-content-between w-100'>
                            <span style={{ fontSize: 16, fontWeight: '700' }}>Sakal</span>
                            <span style={{ color: colors.primary, fontSize: 14, fontWeight: '700' }}>View Article →</span>
                        </div>
                    </a>
                    <div class="modal" tabindex="-1" id="exampleModalToggle" >
                        <div class="modal-dialog  modal-lg" style={{ }}>
                            <div class="modal-content">
                                <div className='d-flex flex-row justify-content-end p-2'>
                                    <button type="button" class="btn-close" style={{justifySelf:"end"}} data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                   <embed src={"https://cspindianetworks.s3.ap-south-1.amazonaws.com/sakal.pdf"} style={{width:"100%",height:"80vh"}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Official References */}
            <div>
                <h2 style={sectionTitleStyle}>
                    Official References
                    <div style={underlineStyle}></div>
                </h2>
                <div style={linkSectionStyle}>
                    <a href="https://gini.org/gdi-winners/2025" target="_blank" rel="noopener noreferrer" style={linkCardStyle} onMouseOver={(e) => e.currentTarget.style.borderColor = colors.primary} onMouseOut={(e) => e.currentTarget.style.borderColor = 'transparent'}>
                        <span style={{ fontSize: isMobile ? '14px' : '16px', fontWeight: '600' }}>GINI Awards 2025 Winners List</span>
                        <span style={{ color: colors.primary, fontSize: isMobile ? '12px' : '14px', fontWeight: '700' }}>Visit Site →</span>
                    </a>
                    <a href="https://gini.org/gdi-distinguished-innovation-private-sector" target="_blank" rel="noopener noreferrer" style={linkCardStyle} onMouseOver={(e) => e.currentTarget.style.borderColor = colors.primary} onMouseOut={(e) => e.currentTarget.style.borderColor = 'transparent'}>
                        <span style={{ fontSize: isMobile ? '14px' : '16px', fontWeight: '600' }}>Distinguished Innovation by Private Sector</span>
                        <span style={{ color: colors.primary, fontSize: isMobile ? '12px' : '14px', fontWeight: '700' }}>Visit Site →</span>
                    </a>
                    <a href="https://gini.org/gdi" target="_blank" rel="noopener noreferrer" style={linkCardStyle} onMouseOver={(e) => e.currentTarget.style.borderColor = colors.primary} onMouseOut={(e) => e.currentTarget.style.borderColor = 'transparent'}>
                        <span style={{ fontSize: isMobile ? '14px' : '16px', fontWeight: '600' }}>GINI Global Innovation Awards Overview</span>
                        <span style={{ color: colors.primary, fontSize: isMobile ? '12px' : '14px', fontWeight: '700' }}>Visit Site →</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default MediaCentre;